<template>
  <div class="density-control" role="group" :aria-label="$t('orders.details.kanban.card_detail')">
    <span class="density-label">{{ $t('orders.details.kanban.density.s') }}</span>
    <input
      type="range"
      class="density-range"
      min="0"
      max="1"
      step="1"
      :value="index"
      :aria-valuetext="density"
      @input="onInput" />
    <span class="density-label">{{ $t('orders.details.kanban.density.m') }}</span>
  </div>
</template>
<script setup lang="ts">
import type { CardDensity } from '@/types/kanban';
import { computed } from 'vue';

const density = defineModel<CardDensity>({ default: 'M' });

const ORDER: CardDensity[] = ['S', 'M'];

const index = computed(() => Math.max(0, ORDER.indexOf(density.value)));

const onInput = (event: Event) => {
  const value = Number((event.target as HTMLInputElement).value);
  density.value = ORDER[value] ?? 'M';
};
</script>
<style scoped>
.density-control {
  display: inline-flex;
  align-items: center;
  gap: 8px;
}

.density-label {
  font-size: 12px;
  font-weight: 600;
  color: #475467;
}

.density-range {
  width: 96px;
  accent-color: #1570ef;
  cursor: pointer;
}
</style>
